// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-viewer[data-v-a2907df4] {\n  background-color: #F0F5F8;\n  border: 1px solid #e8eef1;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n.text-viewer__title[data-v-a2907df4] {\n  font-size: 13px;\n}\n.text-viewer pre[data-v-a2907df4] {\n  white-space: break-spaces;\n}", ""]);
// Exports
module.exports = exports;
